export default function Home() {
    return (
        <div className="flex h-[100vh] w-[100vw] items-center justify-center">
            <h1 className="text-4xl">Blew.</h1>
        </div>
    )
}